import styled from 'styled-components';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Button } from '@components/Button';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { TOP_BANNER_HEIGHT } from '@layout';

export const SectionContainer = styled(Box)`
  padding-top: 100px;
  height: 1050px;
  display: flex;
  align-items: flex-end;
  background-image: url(${cloudAssetUrl('wedding-invitations/hero/images_bg.jpg', { optimization: 'aggressive' })});
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 1400px auto;
  ${themeMediaQuery('below_sm')} {
    height: calc(750px + ${TOP_BANNER_HEIGHT}px);
    padding-top: 90px;
    background-image: url(${cloudAssetUrl('wedding-invitations/hero/images_bg.jpg', { optimization: 'aggressive' })});
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 1000px auto;
  }
  ${themeMediaQuery('sm')} {
    background-size: 1400px auto;
    height: calc(1000px + ${TOP_BANNER_HEIGHT}px);
  }
  ${themeMediaQuery('md')} {
    background-size: 1400px auto;
    height: calc(1000px + ${TOP_BANNER_HEIGHT}px);
  }
  ${themeMediaQuery('lg')} {
    background-size: 1800px auto;
    height: calc(1200px + ${TOP_BANNER_HEIGHT}px);
  }
  ${themeMediaQuery('xl')} {
    background-size: 100% auto;
    height: calc(1450px + ${TOP_BANNER_HEIGHT}px);
  }
`;

export const HeroSectionFullWidthContainer = styled(Box)`
  width: 100%;
`;

// Lottie
export const VideoContainer = styled.div`
  width: 1400px;
  left: calc(50% - 700px);
  position: relative;
  bottom: -5px;
  ${themeMediaQuery('below_sm')} {
    width: 1000px;
    height: auto;
    left: calc(50% - 500px);
  }
  ${themeMediaQuery('sm')} {
    width: 1400px;
    left: calc(50% - 700px);
  }
  ${themeMediaQuery('md')} {
    width: 1400px;
    left: calc(50% - 700px);
  }
  ${themeMediaQuery('lg')} {
    width: 1800px;
    left: calc(50% - 900px);
  }
  ${themeMediaQuery('xl')} {
    width: 100%;
    left: 0;
  }
`;

export const PairedText = styled.div`
  position: absolute;
  left: 50%;
  top: calc(200px + ${TOP_BANNER_HEIGHT}px);
  transform: translateX(-50%);
  width: 100%;
  z-index: 10;
  ${themeMediaQuery('below_sm')} {
    top: calc(100px + ${TOP_BANNER_HEIGHT}px);
  }
`;

export const TextPairingWrapper = styled(TextPairing)`
  .text-pairing-title {
    max-width: 600px;
  }
  .text-pairing-body {
    max-width: 550px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 330px;
      font-size: 32px;
      line-height: 38px;
    }
    .text-pairing-body {
      max-width: 310px;
      font-size: 17px;
      line-height: 27px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 700px;
    }
  }
`;

export const StyledGetStartedButton = styled(Button)``;
